import {
  LICENSE_NUMBER_ERROR_MESSAGE,
  LICENSE_NUMBER_PATTERN,
} from '@/constants';
import type { Validation } from '../types';

export const licenseNumberCharacterValidation: Validation = {
  type: 'pattern',
  value: LICENSE_NUMBER_PATTERN.source,
  message: LICENSE_NUMBER_ERROR_MESSAGE,
};

// Index 0 of the agent card is the primary agent, whose license numbers hydrate
// from identity and render read-only — flagging those gives them nothing to fix.
// The co-agent cards are filled in by hand, so the check still applies there.
const CO_AGENT_CARD_INDEXES = [1, 2, 3];

export const coAgentLicenseNumberCharacterValidation: Validation = {
  ...licenseNumberCharacterValidation,
  appliesToIndex: CO_AGENT_CARD_INDEXES,
};
